import React, { Fragment, useEffect, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, RowText, Status, TableView } from "../../../../../component/index.jsx"
import BootstrapTable from "react-bootstrap-table-next"
import {
  activitySendToErp,
  getDetailSpraying,
  updateAreaActivityImage
} from "../../../../../redux/actions/AreaAction.jsx"
import { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  checkBadgePaymentStatus,
  stringFormatting,
  toMeter,
  toRupiah
} from "../../../../helpers/TextHelper.js"
import { AREA, AREA_ACTIVITY_TYPE, GENERAL } from "../../../../../constants/InitTypeConstants.js"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { Popup, PopupQuestion } from "../../../../../component/atoms/Popup/index.jsx"
import swal from "sweetalert"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { useTranslation } from "react-i18next"
import { ErpNumber } from "../../../../../component/atoms/ErpNumber/ErpNumber.jsx"
import { ACTIVITY_STATUS_ENUM, DATE_TYPE_ENUM } from "../../../../../constants/StringConstant.js"

export const SprayingDetail = ({
  match: {
    params: { status, id, activity_id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { MasterData, General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [pesticide, setPesticide] = useState([])
  const [idDocument, setIdDocument] = useState(null)
  const [dataListMember, setDataListMember] = useState([])
  const [openPopupTableList, setOpenPopupTableList] = useState(false)

  const [showModalDialog, setShowModalDialog] = useState(false)

  useEffect(() => {
    dispatch(getDetailSpraying(activity_id))
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
      setPesticide(Area.data?.pesticide_list)
    }
  }, [Area])

  useEffect(() => {
    if (detail.pic) {
      setDataListMember(detail?.pic)
    }
  }, [detail])

  function checkBeforePlating() {
    return detail.activity_type_enum === AREA_ACTIVITY_TYPE.PRE_PLANTING
  }

  const btnApprove = (
    <Button className={"btn btn-primary"} onClick={() => setShowModalDialog(true)}>
      {t("button_send_to_finance")}
    </Button>
  )

  useEffect(() => {
    if (detail) {
      if (detail?.is_confirmed_erp) {
        subHeader.setButton(null)
      } else {
        subHeader.setButton(btnApprove)
      }
      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_area_name")
        },
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_registered")
        },
        {
          pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
          title: detail?.area_information?.area_name
        },
        {
          title: t("label_spraying")
        }
      ])
    }
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete === true) {
      if (General.actionInitType === GENERAL.UPLOAD) {
        const data = {
          id: detail?.activity_detail_response?.image_and_id_activity[idDocument]?.id,
          url: MasterData.urlResponseUpload
        }
        dispatch(updateAreaActivityImage(data))
      } else if (General.actionInitType === AREA.UPDATE_ACTIVITY_IMAGE) {
        dispatch(getDetailSpraying(activity_id))
      } else if (
        General.loading === false &&
        General.actionInitType === AREA.APPROVE_ACTIVITY_TO_ERP
      ) {
        setShowModalDialog(false)
        swal({
          icon: ILLUSTRATION_CONSTANTS.SUCCESS_FORM,
          text: t("messages_response_activity_approve_to_erp_success")
        })
        dispatch(getDetailSpraying(activity_id))
      }
    }
  }, [General])

  const titleActivity = (
    <ActivityDetailHeader
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.SPRAYING}
      bottomContent={
        <ErpNumber
          noFaktur={detail?.no_faktur}
          noOrderSj={detail?.no_order_sj}
          noOrderSpk={detail?.no_order_spk}
          noOrderErp={detail?.no_order_erp}
          status={detail?.activity_type_enum}
        />
      }
      title={`AKTIVITAS PENYEMPROTAN
          ${checkBeforePlating() ? " PRA-TANAM " : " "} KE-${detail?.activity_detail_response?.seq}
          ${detail?.package_name && !checkBeforePlating() ? `(${detail?.package_name})` : ""}`}
      rightContent={
        <Status
          text={detail?.activity_status_string}
          variant={
            detail?.activity_status_enum === ACTIVITY_STATUS_ENUM.APPROVED ? "completed" : "warning"
          }
        />
      }
    />
  )

  const bills = (
    <Card className={"mb-4"}>
      <CardBody>
        <div className={"d-flex justify-content-between align-items-center"}>
          <h4 className={"mb-6 text-uppercase"}>{t("details_bill")}</h4>
          {checkBadgePaymentStatus(detail?.billing_detail?.payment_status, "mb-6")}
        </div>
        <Card bg={"secondary"}>
          <CardBody className={"px-8 py-6"}>
            <RowModule customColumnCss={"col-md-6"} withoutSeparator={true}>
              <RowText
                label={t("total_bills")}
                value={toRupiah(detail?.billing_detail?.total_bill)}
              />
              <RowText
                label={t("remaining_bill")}
                value={toRupiah(detail?.billing_detail?.remaining_bill)}
              />
              <RowText
                label={t("already_paid")}
                value={toRupiah(detail?.billing_detail?.paid_amount)}
              />
              <RowText
                label={t("paid_date")}
                value={stringFormatting(
                  timeStampToDate(detail?.billing_detail?.paid_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                )}
              />
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  const jenisHama = (data) => {
    if (data) {
      let hama = data.map((item) => item.name)
      return hama.join(", ")
    }
  }

  function dataPic() {
    return (
      <>
        {
          <div>
            {dataListMember.map((item, i) => (
              <>
                {i < 2 && (
                  <Fragment>{`${item.name} (${item.member}) ${
                    checkCommaInDataPic(i, dataListMember.length) ? "," : ""
                  } `}</Fragment>
                )}
              </>
            ))}
            {dataListMember.length > 2 && (
              <span
                onClick={() => setOpenPopupTableList(true)}
                className={"text-success font-weight-bolder  underline-hover cursor-pointer"}
                style={{ fontSize: 12, textDecoration: "underline" }}>
                +{dataListMember.length - 2} Lainnya
              </span>
            )}
          </div>
        }
      </>
    )
  }

  function checkCommaInDataPic(i, length) {
    if (length > 1 && i === 0) {
      return true
    } else if (length === 1) {
      return false
    } else if (length > 2) {
      return true
    } else if (length === 2 && i === 1) {
      return false
    }
  }

  const detailActivitas = (
    <>
      <Card>
        <CardBody>
          <h4 className={"mb-6 text-uppercase"}>INFORMASI LAHAN</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule>
              <RowText label={"Lahan"} value={detail?.area_information?.area_name ?? "-"} />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_manual_area_size")}
                value={
                  detail?.area_information?.area_land_manual
                    ? toMeter(detail?.area_information?.area_land_manual)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_farmer")}
                value={
                  detail?.area_information?.farmer_name
                    ? `${detail?.area_information?.farmer_name} (${detail?.area_information?.farmer_code})`
                    : "-"
                }
                hasIcon={detail?.area_information?.has_kur}
                icon={detail?.area_information?.bank_image}
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_polygon_area_size")}
                value={
                  detail?.area_information?.area_land_polygon
                    ? toMeter(detail?.area_information?.area_land_polygon)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={"Mitra"}
                value={
                  detail?.area_information?.mitra_name
                    ? `${detail?.area_information?.mitra_name} (${detail?.area_information?.mitra_code})`
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              {!checkBeforePlating() && (
                <RowText
                  label={t("label_plant_type")}
                  value={detail?.area_information?.plant_type_name ?? "-"}
                />
              )}
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_area_location")}
                value={detail?.area_information?.full_address ?? "-"}
              />
            </RowModule>
            <RowModule>
              {!checkBeforePlating() && (
                <RowText
                  label={t("label_plant_varieties")}
                  value={detail?.area_information?.variety_name ?? "-"}
                />
              )}
            </RowModule>
          </RowModule>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h4 className={"mb-6 mt-6 text-uppercase"}>Detail Aktivitas</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule>
              <div>
                <RowText
                  label={t("label_submitted_by")}
                  value={
                    detail?.activity_detail_response?.submitted_by
                      ? detail?.activity_detail_response?.submitted_by +
                        " (" +
                        detail?.activity_detail_response?.submitted_by_team +
                        ")"
                      : "-"
                  }
                />
                <RowText
                  label={t("label_submitted_time")}
                  value={
                    detail?.activity_detail_response?.submitted_date
                      ? timeStampToDate(
                          detail?.activity_detail_response?.submitted_date,
                          "dd-MM-yyyy HH:mm:ss"
                        )
                      : "-"
                  }
                />

                <RowText
                  label={t("label_scheduled_working_date")}
                  value={
                    detail?.scheduled_date
                      ? timeStampToDate(detail?.scheduled_date, "dd-MM-yyyy")
                      : "-"
                  }
                />
                <RowText
                  label={t("label_completed_working_date")}
                  value={
                    detail?.activity_detail_response?.activity_date
                      ? timeStampToDate(
                          detail?.activity_detail_response?.activity_date,
                          "dd-MM-yyyy"
                        )
                      : "-"
                  }
                />
                {!checkBeforePlating() && (
                  <RowText
                    label={"HST"}
                    value={stringFormatting(detail?.activity_detail_response?.hst, "HST")}
                  />
                )}

                <RowText
                  label={t("label_spraying_method")}
                  value={detail?.activity_method ?? "-"}
                />
              </div>
            </RowModule>
            <RowModule>
              <div>
                <RowText
                  label={t("label_scheduled_to_team")}
                  value={detail.pic ? dataPic() : "-"}
                />
                <RowText
                  label={t("label_liquid_use")}
                  value={stringFormatting(detail?.liquid_use, "Liter")}
                />
                <RowText
                  label={t("label_warehouse")}
                  value={
                    detail?.activity_detail_response?.warehouse
                      ? detail?.activity_detail_response?.warehouse
                      : "-"
                  }
                />
                <RowText
                  label={t("label_pest_type")}
                  value={detail?.pest_type ? jenisHama(detail?.pest_type) : "-"}
                />
                <RowText
                  label={t("label_alsintan_land_area_worked")}
                  value={
                    detail?.activity_detail_response?.worked_area
                      ? toMeter(detail?.activity_detail_response?.worked_area)
                      : "-"
                  }
                />

                <RowText
                  label={t("label_reason")}
                  value={stringFormatting(detail?.activity_detail_response?.reason)}
                />
              </div>
            </RowModule>
          </RowModule>

          <div className={"my-10"}>
            <h4 className={"mb-6"}>CATATAN</h4>
            <div className={"row mb-4"}>
              {detail?.activity_detail_response?.image_and_id_activity &&
                detail?.activity_detail_response?.image_and_id_activity.map((item, index) => {
                  return (
                    <div className={"col-md-3"} key={index}>
                      <DetailText
                        type="image"
                        value={item.url}
                        indexKey={index}
                        menu={AREA.ACTIVITY_SPRAYING}
                        setIdDocument={setIdDocument}
                      />
                    </div>
                  )
                })}
            </div>
            <span className="font-weight-bold text-dark-50 font-size-sm">
              {!detail?.activity_detail_response?.note
                ? "-"
                : detail?.activity_detail_response?.note}
            </span>
          </div>
        </CardBody>
      </Card>
    </>
  )

  const uiDose = (e) => {
    return (
      <>
        {e?.dose ?? "-"} {e?.unit_doze ?? ""}
      </>
    )
  }

  const uiQtt = (e) => {
    return (
      <>
        {e?.quantity ?? "-"} {e?.unit_used ?? ""}
      </>
    )
  }

  const columns = [
    {
      dataField: "pesticide_name",
      text: t("label_pesticide_name"),
      headerClasses: "bg-gray"
    },
    {
      dataField: "owner_enum_string",
      text: t("label_pesticide_ownership"),
      headerClasses: "bg-gray"
    },
    {
      dataField: "dose",
      text: t("label_dose"),
      headerClasses: "bg-gray",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDose
      }
    },
    {
      dataField: "quantity",
      text: t("label_quantity"),
      headerClasses: "bg-gray",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiQtt
      }
    }
  ]

  const columnsPic = [
    {
      dataField: "name",
      text: t("label_team_name").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      headerStyle: () => {
        return { width: "25%" }
      }
    },
    {
      dataField: "member",
      text: t("label_member").toUpperCase()
    }
  ]

  const pesticideDetail = (
    <Card>
      <CardBody>
        <div className={"pesticideDetail"}>
          <h4 className={"mb-6"}>{t("label_pesticide_detail")}</h4>
          <div className={"border rounded table-small-padding"}>
            <BootstrapTable
              condensed
              bordered={false}
              columns={columns}
              keyField={"pesticide_name"}
              data={pesticide}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  )

  function uiName(e) {
    return <div className={"font-weight-bolder"}>{e?.name ?? "-"}</div>
  }

  function bodyPopupTable() {
    return (
      <div className={"table_list_popup_schedule table_hidden_bottom"}>
        <TableView
          dataTable={dataListMember}
          loadingGetData={false}
          columnProperties={columnsPic}
        />
      </div>
    )
  }

  return (
    <>
      <Popup
        contentClassName={"modal-main modal_detail_team_customs"}
        show={openPopupTableList}
        titleCustom={<h1>{t("label_team_member")}</h1>}
        closeButton={true}
        showButton={false}
        onClick={() => setOpenPopupTableList(false)}
        body={bodyPopupTable()}
        size={"lg"}
        onCancel={() => {
          setOpenPopupTableList(false)
        }}
      />
      <PopupQuestion
        onCancel={() => setShowModalDialog(false)}
        textCancel={t("button_cancel")}
        textOk={t("button_continue")}
        title={t("messages_title_activity_send_to_erp")}
        onOk={() => {
          dispatch(activitySendToErp(activity_id, {}))
          setShowModalDialog(false)
        }}
        show={showModalDialog}
        bodyCustom={
          <RowModule>
            <p className={"swal-text p-4"}>
              {t("messages_confirmation_activity_approve_to_erp_confirmation")}
            </p>
          </RowModule>
        }
      />
      <div className={"w-100 d-flex flex-column"} style={{ gap: 12 }}>
        {titleActivity}
        { detail?.billing_detail?.payment_status && bills}
        {detailActivitas}
        {pesticide && pesticideDetail}
      </div>
    </>
  )
}